<template>
  <div class="switch-content">
    <span class="switch-texts"
          @click="changeValue(false)">
      {{ valueLeft }}
    </span>
    <div class="onoffswitch">
      <input id="myonoffswitch"
             :checked="value"
             :class="{center: getCheck}"
             type="checkbox"
             name="onoffswitch"
             class="onoffswitch-checkbox"
             @input="inputChange">
      <label class="onoffswitch-label"
             for="myonoffswitch">
        <span class="onoffswitch-inner" />
        <span id="onoffswitch-switch"
              :style="styleProc"
              class="onoffswitch-switch"
              @touchstart.prevent="dragStart"
              @mousedown="dragStart" />
      </label>
    </div>
    <span class="switch-texts"
          @click="changeValue(true)">
      {{ valueRight }}
    </span>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: undefined
    },
    valueLeft: {
      type: String,
      default: 'false'
    },
    valueRight: {
      type: String,
      default: 'true'
    }
  },
  data: () => ({
    width: 48,
    position: 0
  }),
  computed: {
    getCheck: function() {
      return this.value === undefined
    },
    styleProc: function() {
      return {
        left: `${(this.position / 100) * (this.width - 23)}px`
      }
    },
    pos_percentage() {
      return `${this.position - 50}%`
    }
  },
  methods: {
    inputChange: function($event) {
      this.$emit('input', $event.target.checked)
      this.resolvePosition($event.target.checked)
    },
    changeValue: function(newValue) {
      this.$emit('input', newValue)
      this.$el.querySelector('#myonoffswitch').checked = newValue
      this.resolvePosition(newValue)
    },
    dragStart: function() {
      window.addEventListener('touchmove', this.dragging)
      window.addEventListener('touchend', this.dragStop)
      window.addEventListener('mousemove', this.dragging)
      window.addEventListener('mouseup', this.dragStop)
    },
    dragging: function(e) {
      var pos = 0
      if (e.clientX) {
        pos = e.clientX - this.$el.querySelector('.onoffswitch').offsetLeft
      } else {
        pos =
          e.touches[0].clientX -
          this.$el.querySelector('.onoffswitch').offsetLeft
      }
      const percent = (pos / this.width) * 100
      this.position = percent <= 0 ? 0 : percent >= 100 ? 100 : percent
    },
    dragStop: function(e) {
      window.removeEventListener('touchmove', this.dragging)
      window.removeEventListener('touchend', this.dragStop)
      window.removeEventListener('mousemove', this.dragging)
      window.removeEventListener('mouseup', this.dragStop)
      if (this.position > 50) {
        this.changeValue(true)
      } else {
        this.changeValue(false)
      }
    },
    resolvePosition(value) {
      this.position = value ? 100 : 0
    }
  }
}
</script>

<style lang="scss">
@import './wswitch.sass';
</style>
